(function(){
  var WHATSAPP_NUMBER = '27785430663';

  function getSASTNow(){
    var now = new Date();
    var utc = now.getTime() + (now.getTimezoneOffset()*60000);
    return new Date(utc + 2*3600000);
  }

  function t(h,m){ return h*60+m; }

  function getMode(){
    var d = getSASTNow();
    var day = d.getDay();
    var mins = d.getHours()*60 + d.getMinutes();

    if(day>=1 && day<=5){
      if(mins>=t(8,0) && mins<t(15,30)) return {mode:'normal'};
      if(mins>=t(15,30) && mins<t(20,30)) return {mode:'whatsapp'};
      if(mins<t(8,0)) return {mode:'closed', next:'today at 8:00am'};
      return {mode:'closed', next: day===5 ? 'Saturday at 3:30pm' : 'tomorrow at 8:00am'};
    }
    if(day===6){
      if(mins>=t(15,30) && mins<t(20,30)) return {mode:'whatsapp'};
      if(mins<t(15,30)) return {mode:'closed', next:'today at 3:30pm'};
      return {mode:'closed', next:'Sunday at 10:00am'};
    }
    if(mins>=t(10,0) && mins<t(16,30)) return {mode:'whatsapp'};
    if(mins<t(10,0)) return {mode:'closed', next:'today at 10:00am'};
    return {mode:'closed', next:'Monday at 8:00am'};
  }

  function applyMode(){
    var result = getMode();
    var mode = result.mode, next = result.next;
    document.body.setAttribute('data-shop-mode', mode);

    var banner = document.getElementById('shop-hours-banner');
    if(banner) banner.remove();

    if(mode === 'closed'){
      banner = document.createElement('div');
      banner.id = 'shop-hours-banner';
      banner.style.cssText = 'background:#a82f2c;color:#fff;text-align:center;padding:12px 16px;font-size:14px;font-weight:600;position:relative;z-index:999;';
      banner.textContent = "We're currently closed for orders. Opens " + next + ".";
      document.body.prepend(banner);
    } else if(mode === 'whatsapp'){
      banner = document.createElement('div');
      banner.id = 'shop-hours-banner';
      banner.style.cssText = 'background:#25D366;color:#fff;text-align:center;padding:12px 16px;font-size:14px;font-weight:600;position:relative;z-index:999;';
      banner.textContent = 'After-hours ordering: order via WhatsApp for same-day collection or Uber delivery.';
      document.body.prepend(banner);
    }

    swapButtons(mode);
  }

  function swapButtons(mode){
      var buttons = document.querySelectorAll('form[action*="/cart/add"] button[type="submit"], .product-form__submit, [name="add"], [id^="ProductSubmitButton"], [id^="AddToCart"]');

    buttons.forEach(function(btn){
      if(btn.dataset.origText === undefined){
        btn.dataset.origText = btn.textContent;
      }
      if(mode === 'normal'){
        btn.disabled = false;
        btn.textContent = btn.dataset.origText;
        btn.onclick = null;
        btn.classList.remove('whatsapp-mode','closed-mode');
      } else if(mode === 'whatsapp'){
        btn.disabled = false;
        btn.textContent = 'Order via WhatsApp';
        btn.classList.add('whatsapp-mode');
        btn.classList.remove('closed-mode');
        btn.onclick = function(e){
          e.preventDefault();
          var productTitle = (document.querySelector('h1') && document.querySelector('h1').textContent.trim()) || 'this product';
          var msg = encodeURIComponent('Hi! I\'d like to order: ' + productTitle);
          window.open('https://wa.me/' + WHATSAPP_NUMBER + '?text=' + msg, '_blank');
        };
      } else {
        btn.disabled = true;
        btn.textContent = 'Currently closed';
        btn.classList.add('closed-mode');
        btn.classList.remove('whatsapp-mode');
      }
    });
  }

  applyMode();
  setInterval(applyMode, 60000);
})();
